// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GZs64","iconBox":"styles_iconBox__vMHTk","content":"styles_content__cvP6X","group":"styles_group__chDJr"};